/* Original Damroo recording: user-selected 2–3 second excerpt. */
(() => {
  const audio = new Audio(new URL('damroo-welcome.mp3', document.currentScript.src).href);
  audio.preload = 'auto';
  audio.volume = 0.55;
  const control = document.createElement('button');
  control.className = 'brand-sound-control';
  control.type = 'button';
  control.innerHTML = '<span aria-hidden="true">♫</span><span class="sound-label">Play Damroo sound</span>';
  document.body.append(control);
  let muted = false, pending = false;
  try { muted = localStorage.getItem('damroo-sound-muted') === 'true'; } catch {}
  function label(text, accessible = text) {
    control.querySelector('.sound-label').textContent = text;
    control.setAttribute('aria-label', accessible);
  }
  function removeFallback() {
    document.removeEventListener('pointerdown', firstGesture);
    document.removeEventListener('keydown', firstGesture);
  }
  function stop() {
    audio.pause(); audio.currentTime = 0;
    control.classList.remove('is-playing');
  }
  async function play() {
    if (muted || pending || !audio.paused || document.hidden) return;
    pending = true;
    try {
      audio.currentTime = 0;
      await audio.play();
      if (muted || document.hidden) { stop(); return; }
      control.classList.add('is-playing');
      label('Sound on · mute', 'Mute Damroo sound');
      removeFallback();
    } catch (error) {
      label(error.name === 'NotAllowedError' ? 'Play Damroo sound' : 'Retry Damroo sound');
    } finally { pending = false; }
  }
  function firstGesture(event) {
    if (control.contains(event.target) || (event.type === 'keydown' && !['Enter', ' '].includes(event.key))) return;
    play();
  }
  control.addEventListener('click', () => {
    if (!audio.paused) {
      stop(); muted = true; removeFallback(); label('Sound muted · play', 'Play Damroo sound');
    } else { muted = false; play(); }
    try { localStorage.setItem('damroo-sound-muted', String(muted)); } catch {}
  });
  audio.addEventListener('ended', () => {
    control.classList.remove('is-playing'); label('Replay Damroo sound');
  });
  audio.addEventListener('error', () => {
    control.classList.remove('is-playing'); label('Retry Damroo sound');
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && !audio.paused) { stop(); label('Replay Damroo sound'); }
  });
  if (muted) label('Sound muted · play', 'Play Damroo sound');
  else {
    label('Play Damroo sound');
    document.addEventListener('pointerdown', firstGesture);
    document.addEventListener('keydown', firstGesture);
    play();
  }
})();
